import { Component, OnInit, Input, Injector } from "@angular/core";
import { DataService } from "../../services/data/data.service";
import { TradeLines } from "../../interfaces/service.response";
import { MainUIServiceService } from "../../services/main-uiservice.service";
import { AppComponentBase } from "../../services/AppComponentBase";

@Component({
    selector: "balance-info",
    template: require('./balance-info.component.html'),
    styles: [require('./balance-info.component.css')]
})
export class BalanceInfoComponent extends AppComponentBase {
    balance: number = 0;
    marginInUse: number = 0;
    sumOfPips: number = 0;
    sumOfUplUsd: number = 0;
    sumOfPipsHistory: number = 0;
    sumOfPlUsdHistory: number = 0;
    marginInUsePercetage = 0;
    marginInUsePercetegeFontSizePx = 11;
    freeMarginFontSizePx = 11;
    maxMarginPercatageFontSizePx = 11;
    get marginInUseBarWidthPx() {
        return this.marginInUsePercetage > 99 ? 33 : 30;
    }

    get freeMarginBarWidthPx() {
        return this.freeMarginPercetage > 99 ? 33 : 30;
    }

    freeMargin = 0;
    freeMarginPercetage = 0;

    @Input()
    floatRight = true;

    public _activeSymbolType: string = "_orders";
    constructor(injector: Injector, protected dataService: DataService, protected mainUIService: MainUIServiceService) {
        super(injector);
        this.dataService.dataSubscriber.subscribe(response => {
            if (response) {
                switch (response.Type) {
                    case "SwitchProviderRs":
                        this.balance = 0;
                        this.marginInUse = 0;
                        this.freeMargin = 0;
                        this.sumOfPips = 0;
                        this.sumOfUplUsd = 0;
                        this.marginInUsePercetage = 0;
                        this.freeMarginPercetage = 0;
                        this.marginInUsePercetegeFontSizePx = 0;
                        this.freeMarginFontSizePx = 0;
                        this.workspace.sumOfUplUsd = 0;

                        this.sumOfPipsHistory = 0;
                        this.sumOfPlUsdHistory = 0;
                        break;
                    case "TradeLines":
                        var trendLines: TradeLines = <TradeLines>response;
                        if (trendLines.MoneyLine) {
                            this.balance = trendLines.MoneyLine.Balance || 0;
                            this.marginInUse = trendLines.MoneyLine.MarginInUse || 0;
                            this.freeMargin = this.balance - this.marginInUse;
                            this.sumOfPips = trendLines.MoneyLine.SumOfPips || 0;
                            this.sumOfUplUsd = trendLines.MoneyLine.SumOfUPLUSD || 0;
                            try {
                                this.marginInUsePercetage = Math.ceil(
                                    (this.marginInUse / (trendLines.MoneyLine.Balance || 0)) * 100
                                );
                                this.freeMarginPercetage = 100 - this.marginInUsePercetage;
                                this.marginInUsePercetegeFontSizePx = Math.min(
                                    ((this.marginInUsePercetage *
                                        this.maxMarginPercatageFontSizePx *
                                        this.marginInUseBarWidthPx) /
                                        130) *
                                        0.0363,
                                    this.maxMarginPercatageFontSizePx
                                );
                                this.freeMarginFontSizePx = Math.min(
                                    (((100 - this.marginInUsePercetage) *
                                        this.maxMarginPercatageFontSizePx *
                                        this.marginInUseBarWidthPx) /
                                        130) *
                                        0.0136,
                                    this.maxMarginPercatageFontSizePx
                                );
                            } catch (e) {
                                console.error(e);
                            }

                            this.workspace.sumOfUplUsd = this.sumOfUplUsd;

                            this.lastPips = trendLines.MoneyLine.SumOfPipsHistory || 0
                            this.lastPnl = trendLines.MoneyLine.SumOfPLUSDHistory || 0
                            if(!this.activeHistory)
                            {
                                this.sumOfPipsHistory = trendLines.MoneyLine.SumOfPipsHistory || 0;
                                this.sumOfPlUsdHistory = trendLines.MoneyLine.SumOfPLUSDHistory || 0;
                            }
                            
                        }
                }
            }
        });

        this.mainUIService.TabsActive.subscribe(v => {
            if (v != this.activeSymbolType) {
                this.activeSymbolType = v;
            }
        });

        this.globaGridMode.historyUpdate.subscribe(v=>{
            this.sumOfPipsHistory = this.workspace.historyPips;
            this.sumOfPlUsdHistory = this.workspace.historyPNL;
        })
        
        this.globaGridMode.dateFilter.subscribe(v=>{
            if(v!="all" && v!=null)
            {
            this.activeHistory = true;
            console.log(this.workspace.pdfReportHistoryDateRange.from);
            console.log(this.workspace.pdfReportHistoryDateRange.to);
            if(this.workspace.pdfReportHistoryDateRange.from && this.workspace.pdfReportHistoryDateRange.to) {
            //      this.workspace.GetPnLInTimeRange(this.workspace.currentAccountInformation.id, this.workspace.pdfReportHistoryDateRange.from, this.workspace.pdfReportHistoryDateRange.to).then(response => {
                     
            //          if(response)
            //          {
                         
            //              this.sumOfPipsHistory = response.sumOfPips;

            //              if(response.accountBalance)
            //              {
            //                  this.sumOfPlUsdHistory = response.accountBalance[0].pnLInTimeRange
            //              }
                         
            //          }
                     
            // })
            this.sumOfPipsHistory = this.workspace.historyPips;
            this.sumOfPlUsdHistory = this.workspace.historyPNL;
           }
           else
           {
            this.activeHistory = false;
            this.sumOfPipsHistory = this.lastPips;
            this.sumOfPlUsdHistory = this.lastPnl;
           }
           }
           else
           {
               this.activeHistory = false;
               this.sumOfPipsHistory = this.lastPips;
               this.sumOfPlUsdHistory = this.lastPnl;
           }
        })
    }

    public activeHistory:boolean = false;
    public lastPips:number = 0;
    public lastPnl:number = 0;
    public get currencySymbol() {
        return this.workspace.getCurrencyInformation(this.workspace.currentAccountCurrencyCode).symbol;
    }

    public get currencySymbolZ() {
        return "(" + this.workspace.getCurrencyInformation(this.workspace.currentAccountCurrencyCode).symbol + ")";
    }

    public get activeSymbolType(): string {
        return this._activeSymbolType;
    }

    public set activeSymbolType(v: string) {
        this._activeSymbolType = v;
    }

    get intsumOfPips() {
        return Math.round(this.sumOfPips);
    }

    get intsumOfPipsHistory() {
        return Math.round(this.sumOfPipsHistory);
    }
}
